/* unplugin-vue-components disabled */import { render } from "./previewImg.vue?vue&type=template&id=365d9974&scoped=true"
import script from "./previewImg.vue?vue&type=script&lang=js"
export * from "./previewImg.vue?vue&type=script&lang=js"

import "./previewImg.vue?vue&type=style&index=0&id=365d9974&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365d9974"]])

export default __exports__